export default "__VITE_ASSET__Doq1SCod__"